import "reflect-metadata";
import { injectable } from 'inversify-props'
import { AssistenteIAServiceAdapter } from '@/usecases';
import { perguntar, buscarMensagens, criarNovaThread } from "@/api/assistenteIA";
import { AxiosRequestConfig } from "axios";
import { MensagemAssistenteIA } from "@/models/assistente-ia";

@injectable()
export class AssistenteIAService implements AssistenteIAServiceAdapter {
	perguntar = async (params?: any, config?: AxiosRequestConfig): Promise<string> => await perguntar(params, config)

	buscarMensagens = async (config?: AxiosRequestConfig): Promise<MensagemAssistenteIA[]> => await buscarMensagens(config)

	criarNovaThread = async (): Promise<void> => await criarNovaThread()
}